import { UserGroupType } from '@navio/nsdk';
import type { ShipperGroup } from '@navio/observability';

const USER_GROUP_ANALYTICS_TYPE = {
  organization: 'organization',
  userGroup: 'user_group'
} as const;

export const USER_GROUP_ANALYTICS_TYPES = [
  USER_GROUP_ANALYTICS_TYPE.organization,
  USER_GROUP_ANALYTICS_TYPE.userGroup
] as const;

type AnalyticsUserGroup = {
  id: number;
  name: string;
  isOrganization: boolean;
  type: UserGroupType;
};

const isOrganizationGroup = (userGroup: AnalyticsUserGroup) =>
  userGroup.isOrganization || userGroup.type === UserGroupType.ORGANIZATION;

export function resolveSelectedUserGroup<T extends { id: number; isSelected: boolean }>(
  userGroups: T[],
  selectedGroupId: number | undefined
): T | undefined {
  return (
    userGroups.find((userGroup) => userGroup.id === selectedGroupId) ??
    userGroups.find((userGroup) => userGroup.isSelected)
  );
}

// OpenPanel / Mixpanel groups for the selected user group. Always tags
// `user_group`; also tags `organization` when the group is a B2B org.
// Login payloads expose the user-group id only (no separate organization id).
export function toUserGroupAnalyticsGroups(userGroup: AnalyticsUserGroup | undefined | null): ShipperGroup[] {
  if (!userGroup) {
    return [];
  }

  const id = String(userGroup.id);
  const { name } = userGroup;
  const groups: ShipperGroup[] = [{ type: USER_GROUP_ANALYTICS_TYPE.userGroup, id, name }];

  if (isOrganizationGroup(userGroup)) {
    groups.push({ type: USER_GROUP_ANALYTICS_TYPE.organization, id, name });
  }

  return groups;
}
